import { LeadsView } from '../components/leads/LeadsView';

/**
 * Global Leads page (CLE-191). Renders the shared <LeadsView /> unscoped, so
 * the pipeline selector and "All pipelines" filter are available.
 */
export function LeadsPage() {
  return (
    <div className="w-full p-4 sm:p-6 lg:p-8">
      <LeadsView />
    </div>
  );
}
